import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "check",
  "use": "check-usage",
  "viewBox": "0 0 14 11",
  "content": "<symbol viewBox=\"0 0 14 11\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"check\">\n<path d=\"M4.32995 8.72948L1.43828 5.83781C1.28259 5.68177 1.07121 5.59408 0.850781 5.59408C0.63035 5.59408 0.418974 5.68177 0.263281 5.83781C-0.0617187 6.16281 -0.0617187 6.68781 0.263281 7.01281L3.74661 10.4961C4.07161 10.8211 4.59661 10.8211 4.92161 10.4961L13.7383 1.67948C14.0633 1.35448 14.0633 0.82948 13.7383 0.50448C13.5826 0.348436 13.3712 0.260742 13.1508 0.260742C12.9303 0.260742 12.719 0.348436 12.5633 0.50448L4.32995 8.72948Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/sharedComponents/Icon/images/check.svg
// module id = 0D5K
// module chunks = 13